export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./games.vue?vue&type=template&id=7aa1fc5e"


//////////////////
// WEBPACK FOOTER
// ./src/components/stats/games.vue?vue&type=template&id=7aa1fc5e
// module id = B+vG
// module chunks = 0